import { Events } from "./events"

const props = {}
const listeners = {}

export const LocalProps = {

  SIDEBAR: 'charizard.sidebar',
  AWARENESS: 'charizard.awareness',

  get(name: string) {
    if (name in props) {
      return props[name]
    }
    return load(name)
  },

  toggle(name: string) {
    this.set(name, !this.get(name))
  },

  set(name: string, value: any) {
    const oldValue = props[name]
    props[name] = value;
    save(name, value);
    let ls = listeners[name];
    if (ls) {
      ls.forEach(l => l(value, oldValue))      
    }
  },

  listen(name: string, cb) {

    let ls = listeners[name];
    if (!ls) {
      ls = new Set();
      listeners[name] = ls;
    }
    ls.add(cb)

    if (!(name in props)) {
      props[name] = load(name)
    }

    setTimeout(() => cb(props[name], null))    

    return () => {
      const ls = listeners[name];
      if (ls) {
        ls.delete(cb)
        if (ls.size === 0) {
          delete listeners[name];
        }
      }      
    }

  },

  transient(name: string) {
    transients.add(name)
  },

  pipe(eventName: string, propName: string) {
    Events.listen(eventName, e => {
      LocalProps.set(propName, e.detail)
    })
  }
}

function isTransient(name: string) {
  return transients.has(name)
}

const transients = new Set();

export function DisposalGroup(...disposers) {
  return () => {
    disposers.forEach(d => d())
  }
}

function save(name: string, value: any) {
  if (isTransient(name)) {
    return;
  }
  localStorage[name] = JSON.stringify(value)
}

function load(name: string) {
  if (isTransient(name)) {
    return;
  }
  const item = localStorage.getItem(name)
  if (item) {
    try {
      return JSON.parse(item)
    } catch(ignore) {
      return undefined
    }
  }
  return undefined
  
}


LocalProps.transient(LocalProps.AWARENESS)
LocalProps.pipe(Events.AWARENESS, LocalProps.AWARENESS)
